import { css } from 'styled-components';
import { viewportBreakpoints } from './breakpoints.js';

const mediaDesktop = `@media screen and (min-width: ${viewportBreakpoints.TABLET + 1}px)`;
const mediaTablet = `@media screen and (max-width: ${viewportBreakpoints.TABLET}px)`;
const mediaMobile = `@media screen and (max-width: ${viewportBreakpoints.MOBILE}px)`;
const mediaNotMobile = `@media screen and (min-width: ${viewportBreakpoints.MOBILE + 1}px)`;
const mediaSidebarBottom = `@media screen and (max-width: ${viewportBreakpoints.SIDEBAR_BOTTOM}px)`;
const mediaXS = `@media screen and (max-width: ${viewportBreakpoints.XS}px)`;
const mediaXSS = `@media screen and (max-width: ${viewportBreakpoints.XSS}px)`;
const mediaHover = `@media (hover: hover) and (pointer: fine)`;
const mediaNotHover = `@media (hover: none)`;
const cssTextEllipsis = css([
  `overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`
]);
const cssLineClamp = (lines) => css([
  ``,
  `;@supports (-webkit-line-clamp:`,
  `){white-space:initial;display:-webkit-box;-webkit-line-clamp:`,
  `;-webkit-box-orient:vertical;}`
], cssTextEllipsis, lines, lines);
const hasHover = `@media (hover: hover)`;

export { cssLineClamp, cssTextEllipsis, hasHover, mediaDesktop, mediaHover, mediaMobile, mediaNotHover, mediaNotMobile, mediaSidebarBottom, mediaTablet, mediaXS, mediaXSS };
//# sourceMappingURL=styled-utils.js.map
